$(function () {
    var form = document.getElementById('js-modal-form');
    if (form) {
        form = new TurboForm(form, {
            errorClassForGroup: 'form__group--error',
            fieldLineClass: 'form__group',
            errorBoxSelector: '.js-form-error-box',
        });

        form.showSuccessMessage = function (message) {
            var wrapper = $(this.form).closest('.js-form-wrap'),
                successBlock = wrapper.next();

            successBlock.find('.form__success_title').text(this.response.name + ', Ваша заявка принята.');
            successBlock.find('.form__success_text').html(message);
            successBlock.slideDown();
            wrapper.slideUp();
            YM_GOAL('CONSULT_FORM');
        };

        form.showErrorMessage = function (message) {
            if (this.errorBox) {
                this.errorBox.textContent = message;
                this.errorBox.style.display = 'block';
            }
        };

        form.showPreloader = function () {
            this.form.classList.add('form--sending');
        };

        form.hidePreloader = function () {
            this.form.classList.remove('form--sending');
        };
    }
});
